
import MotionLayout from '../../general/framer-motion/MotionLayout';
import { useLoading } from '../../../context/LoadingContext';
import React,{  useEffect } from 'react';

const Index = () => {
    const { loading, setLoading } = useLoading();

    useEffect(() => {
        setLoading(false)
    }, []);

    return (
        <MotionLayout>
            <div className='coming-soon-container' style={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
            }}>
                <h1 style={{
                    fontSize: '1.5rem',
                }}>Duplicate tab is not allowed</h1>
            </div>
        </MotionLayout>
    );
};

export default Index;




  
